import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesPreview from './components/ServicesPreview';
import PortfolioPreview from './components/PortfolioPreview';
import InfoPreview from './components/InfoPreview';
import FAQPreview from './components/FAQPreview';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#localbusiness`,
      name: '필그린 인테리어',
      alternateName: 'feel green',
      description: '강남 인테리어 전문 필그린. 아파트·빌라·오피스텔·상업공간 시공, 30년 노하우로 평당 최적화 설계.',
      url: SITE_URL,
      telephone: '010-5350-7926',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '양재대로55길6 종합상가 203호',
        addressLocality: '강남구',
        addressRegion: '서울특별시',
        postalCode: '06336',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 37.4851,
        longitude: 127.0384,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Saturday'],
          opens: '10:00',
          closes: '15:00',
        },
      ],
      priceRange: '₩₩₩',
      areaServed: '서울특별시 강남구',
      serviceType: ['아파트 인테리어', '빌라 인테리어', '오피스텔 인테리어', '상업공간 인테리어', '사무실 인테리어'],
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: SITE_URL,
      name: '필그린 인테리어',
      inLanguage: 'ko-KR',
    },
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: SITE_URL,
      name: '필그린 인테리어 | 강남 아파트·빌라·상업공간 전문 시공',
      description: '강남 인테리어 전문 필그린. 아파트·빌라·오피스텔·상업공간 시공, 30년 노하우로 평당 최적화 설계.',
      isPartOf: { '@id': `${SITE_URL}/#website` },
      about: { '@id': `${SITE_URL}/#localbusiness` },
      inLanguage: 'ko-KR',
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    document.title = '필그린 인테리어 | 강남 아파트·빌라·상업공간 전문 시공';
    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.content = content;
    };
    setMeta('description', '강남 인테리어 전문 필그린. 아파트·빌라·오피스텔·상업공간 시공, 30년 노하우로 평당 최적화 설계. 무료 상담 및 견적 문의 환영.');
    setMeta('og:title', '필그린 인테리어 | 강남 아파트·빌라·상업공간 전문 시공', true);
    setMeta('og:url', SITE_URL, true);

    const scriptId = 'jsonld-home';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) { script = document.createElement('script'); script.id = scriptId; script.type = 'application/ld+json'; document.head.appendChild(script); }
    script.textContent = JSON.stringify(jsonLd);
    return () => { document.getElementById(scriptId)?.remove(); };
  }, []);

  return (
    <div>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesPreview />
        <PortfolioPreview />
        <InfoPreview />
        <FAQPreview />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
